/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {formatMessage: f} = useIntl()
  const {currentUser} = useAuth()
  const [isAccount, setIsAccount] = useState<boolean>(false)

  useEffect(() => {
    const isAccount = localStorage.getItem('isAccount')
    if (isAccount === 'true') {
      setIsAccount(true)
    } else {
      setIsAccount(false)
      localStorage.setItem('isAccount', 'false')
    }
  }, [currentUser])

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={f({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      {/* Only show Claim Management if user has view access */}
      {currentUser?.menuAccess?.claim.view && (
        <SidebarMenuItem
          to='/claims'
          icon='book'
          title={f({id: 'MENU.CLAIM_MANAGEMENT'})}
          fontIcon='bi-layers'
        />
      )}

      {/* <SidebarMenuItem
        to='/settlement'
        icon='calculator'
        title='Claim Settlement'
        fontIcon='bi-layers'
      /> */}

      {/* Manual Activation Management */}
      {currentUser?.roleId === 6 ||
        (currentUser?.roleId === 1 && (
          <SidebarMenuItem
            to='/manual-activation'
            icon='lock'
            title={f({id: 'MENU.MANUAL_ACTIVATION'})}
            fontIcon='bi-lock'
          />
        ))}

      {/* Account Management */}
      {currentUser?.menuAccess?.accountprovider.view ||
        (currentUser?.menuAccess?.accountprovider.create && (
          <SidebarMenuItem
            to='/account'
            icon='profile-circle'
            title={f({id: 'MENU.ACCOUNT'})}
            fontIcon='bi-person'
          />
        ))}

      <SidebarMenuItem
        to='/notifications'
        icon='notification'
        title={f({id: 'MENU.NOTIFICATIONS'})}
        fontIcon='bi-app-indicator'
      />
    </>
  )
}

export {SidebarMenuMain}
